import React from "react";
import { Modal, Button } from "antd";
import {
  IconAlertSquareRounded,
  IconSquareRoundedPlus,
  IconSquareRoundedX,
} from "@tabler/icons-react";

const ConfirmModal = ({
  showModal,
  setShowModal,
  cancelHandler,
  submitHandler,
  variant = "confirm",
  title = "-",
  description,
}) => {
  let primaryColor = "primary";
  let IconComponent = null;
  let IconColor = "";
  let modalSubmitText = "Тийм";
  let modalCancelText = "Үгүй";

  switch (variant) {
    case "warning":
      primaryColor = "orange";
      IconComponent = IconAlertSquareRounded;
      IconColor = "#FA8C16";
      modalSubmitText = "Тийм";
      break;

    case "error":
      primaryColor = "danger";
      IconComponent = IconSquareRoundedX;
      IconColor = "#FF4D4F";
      modalSubmitText = "Тийм";
      break;

    default:
      primaryColor = "primary";
      IconComponent = IconSquareRoundedPlus;
      IconColor = "#0066ff";
      break;
  }

  const handleCancel = () => {
    if (typeof cancelHandler === "function") {
      cancelHandler();
    }
    setShowModal(false);
  };

  const handleOk = () => {
    if (typeof submitHandler === "function") {
      submitHandler();
    }
    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      closable={false}
      footer={null}
      width={400}
      style={{ top: 200, zIndex: 99 }}
    >
      <div className="d-flex flex-row align-items-center gap-2 mb-3">
        {IconComponent && <IconComponent size={26} color={IconColor} />}
        <h6>{title}</h6>
      </div>

      <p style={{}}>{description}</p>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 8,
          marginTop: 34,
        }}
      >
        <Button
          variant="filled"
          color="default"
          style={{ height: "40px", padding: "0 30px" }}
          onClick={handleCancel}
        >
          {modalCancelText}
        </Button>
        <Button
          variant="solid"
          color={primaryColor}
          style={{ height: "40px", padding: "0 30px" }}
          onClick={handleOk}
        >
          {modalSubmitText}
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
